import http from "../../http";

/** 故障报修工单 — /resident/api/resident/houseRepairTicket */
const BASE = "/resident/api/resident/houseRepairTicket";

export default {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  selectById(r) {
    return http.get(`${BASE}/detail`, r);
  },
  contact(r) {
    return http.tip.post(`${BASE}/contact`, r);
  },
  done(r) {
    return http.payload(`${BASE}/done`, r);
  },
};
